import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useLocation, useNavigate } from 'react-router-dom';

const Container = styled.section`
  background-color: #ededed;
  min-height: 1100px;
  padding: 67px 0;
  
  @media (max-width: 479px) {
    min-height: 720px;
    padding: 10px 0;
  }
`;

const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const Title = styled.h2`
  color: #343434;
  font-size: 42px;
  font-family: 'Geologica', Arial, sans-serif;
  font-weight: 700;
  margin-bottom: 100px;
  
  @media (max-width: 479px) {
    font-size: 21px;
    margin-bottom: 53px;
  }
`;

const ToursWrapper = styled.div`
  margin-bottom: 40px;
  
  .tv-hot-tours {
    width: 100%;
  }
`;

const ImageSlider = styled.div`
  .tv-image-slider {
    width: 100%;
  }
`;

const HotTours = () => {
  const toursRef = useRef(null);
  const sliderRef = useRef(null);
  const scriptLoaded = useRef(false);
  const location = useLocation();
  const navigate = useNavigate();
  const hasReloaded = useRef(false);

  // Проверка на перезагрузку
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.get('reload') === 'true' && !hasReloaded.current) {
      hasReloaded.current = true;
      
      // Удаляем параметр reload из URL
      searchParams.delete('reload');
      const newSearch = searchParams.toString();
      const newUrl = location.pathname + (newSearch ? `?${newSearch}` : '');
      
      // Обновляем URL без параметра reload
      navigate(newUrl, { replace: true });
      
      // Перезагружаем страницу
      window.location.reload();
    }
  }, [location, navigate]);

  useEffect(() => {
    let isMounted = true;
    const currentToursRef = toursRef.current;
    const currentSliderRef = sliderRef.current;

    // Функция загрузки скрипта Tourvisor
    const loadTourvisorScript = () => {
      return new Promise((resolve, reject) => {
        if (window.Tourvisor) {
          resolve();
          return;
        }

        const script = document.createElement('script');
        script.src = 'https://tourvisor.ru/module/init.js';
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
      });
    };

    // Функция инициализации виджетов
    const initWidgets = () => {
      if (window.Tourvisor && isMounted) {
        // Инициализация горящих туров
        if (currentToursRef) {
          const existingTours = currentToursRef.querySelector('.tv-hot-tours');
          if (existingTours) {
            existingTours.innerHTML = '';
          }
          const toursDiv = document.createElement('div');
          toursDiv.className = 'tv-hot-tours tv-moduleid-9984437';
          currentToursRef.appendChild(toursDiv);
        }

        // Инициализация слайдера
        if (currentSliderRef) {
          const existingSlider = currentSliderRef.querySelector('.tv-image-slider');
          if (existingSlider) {
            existingSlider.innerHTML = '';
          }
          const sliderDiv = document.createElement('div');
          sliderDiv.className = 'tv-image-slider tv-moduleid-9984338';
          currentSliderRef.appendChild(sliderDiv);
        }
        
        // Переинициализируем Tourvisor
        if (window.Tourvisor.reinit) {
          window.Tourvisor.reinit();
        }
      }
    };

    // Загружаем скрипт и инициализируем виджеты
    if (!scriptLoaded.current) {
      scriptLoaded.current = true;
      loadTourvisorScript()
        .then(() => {
          // Даем время на загрузку
          setTimeout(() => {
            if (isMounted) {
              initWidgets();
            }
          }, 500);
        })
        .catch(error => {
          console.error('Failed to load Tourvisor script:', error);
        });
    } else {
      initWidgets();
    }

    // Очистка при размонтировании
    return () => {
      isMounted = false;
      if (currentToursRef) {
        const widget = currentToursRef.querySelector('.tv-hot-tours');
        if (widget) {
          widget.innerHTML = '';
        }
      }
      if (currentSliderRef) {
        const widget = currentSliderRef.querySelector('.tv-image-slider');
        if (widget) {
          widget.innerHTML = '';
        }
      }
    };
  }, []);

  return (
    <Container>
      <Content>
        <Title>Горящие туры</Title>
        <ToursWrapper ref={toursRef}>
          <div className="tv-hot-tours tv-moduleid-9984437"></div>
        </ToursWrapper>
        <ImageSlider ref={sliderRef}>
          <div className="tv-image-slider tv-moduleid-9984338"></div>
        </ImageSlider>
      </Content>
    </Container>
  );
};

export default HotTours;